export function replaceWithBr(text) {
  return text.replace(/\n/g, '<br />');
}
